/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ViewerArtistPillButtonQueryVariables = {
    id: string;
};
export type ViewerArtistPillButtonQueryResponse = {
    readonly User_by_pk: {
        readonly id: string;
        readonly username: string;
        readonly ProfilePhoto: {
            readonly id: unknown;
            readonly photoUrl: string;
        } | null;
    } | null;
};
export type ViewerArtistPillButtonQuery = {
    readonly response: ViewerArtistPillButtonQueryResponse;
    readonly variables: ViewerArtistPillButtonQueryVariables;
};



/*
query ViewerArtistPillButtonQuery(
  $id: String!
) {
  User_by_pk(id: $id) {
    id
    username
    ProfilePhoto {
      id
      photoUrl
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "User_by_pk",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Photo",
        "kind": "LinkedField",
        "name": "ProfilePhoto",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "photoUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewerArtistPillButtonQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewerArtistPillButtonQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "339a6ebca29be490609bd72e500e2bd8",
    "id": null,
    "metadata": {},
    "name": "ViewerArtistPillButtonQuery",
    "operationKind": "query",
    "text": "query ViewerArtistPillButtonQuery(\n  $id: String!\n) {\n  User_by_pk(id: $id) {\n    id\n    username\n    ProfilePhoto {\n      id\n      photoUrl\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd637fbdef8a79e27cad66d7f3067ee49';
export default node;
